import { useState } from "react";
import { useLocation } from "react-router-dom";
import Landingheader from './Landingheader';
import Footer from '../Footer';
import axios from 'axios';
import Nprogress from 'nprogress';

Nprogress.configure({SpinLoader: false});

const BookingPage = () => {
  const location = useLocation();
  const { formField = [], name = 'Service',id = null } = location.state || {};
  
  // State to track all dynamic inputs: { "Field Label": "User Value" }
  const [formData,setformData] = useState({});
  const handleInputChange = (label,value) => {
    setformData((prev) => ({
      ...prev,[label]: value
    }));
  }

const HandleForm = async() => {
  Nprogress.start();
 const dataToSend = new FormData();
 dataToSend.append("serviceId", id);
 Object.entries(formData).forEach(([key,value]) => {
dataToSend.append(key,value);
 })
try {
  Nprogress.done();
  const response = await axios.post('https://land-survey-main-server.onrender.com/submissionForm',dataToSend);
  if(response && response.data){
    if(response.data.message){
      alert(response.data.message);
    }
  }
  console.log(response.data);
} catch (err) {
  Nprogress.done();
  console.log(err);
}
}
  
  return (
    <>
    <Landingheader />
    <div className="min-h-screen px-4 py-12 bg-gray-50 sm:px-6 lg:px-8">
      <div className="max-w-xl p-8 mx-auto overflow-hidden bg-white shadow-md rounded-xl">
        
        <header className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900">Book {name}</h2>
          <p className="mt-2 text-sm text-gray-500">Please fill out the additional details below.</p>
        </header>

        <form className="space-y-6" onSubmit={(e) => {
          e.preventDefault();
          HandleForm();
          console.log('you clicked!');
        }}>
          {formField.length > 0 ? (
            formField.map((field, i) => (
              <div key={i} className="flex flex-col">
                <label className="block mb-1 text-sm font-semibold text-gray-700">
                  {field.text}
                </label>

                {/* Render Text Input */}
                {field.type === 'Text' && (
                  <input
                    type="text"
                   required = {field.required}
                    placeholder= {field.placeholder}
                    className="w-full px-4 py-2 text-gray-700 transition-all border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    onChange={(e) => handleInputChange(field.text,e.target.value)}/>
                )}

                 {/* Render Number Input */}
                 {field.type === 'Number' && (
                  <input type="tel" className="w-full px-4 py-2 text-gray-700 transition-all border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder= {field.placeholder}  required = {field.required}    onChange={(e) => handleInputChange(field.text,e.target.value)}/>
                 )}

                {/* Render Email Input */}
                 {field.type === 'Email' && (
                  <input type="email" className="w-full px-4 py-2 text-gray-700 transition-all border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder= {field.placeholder}   onChange={(e) => handleInputChange(field.text,e.target.value)} required = {field.required}/>
                 )}


                  {/* Render file upload Input */}
                 {field.type === 'File' && (
                  <label className="flex items-center justify-center w-full px-4 py-2 text-white transition-all bg-blue-700 border border-gray-300 rounded-lg outline-none justi focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                 {field.placeholder}
                     <input type="file"   onChange={(e) => handleInputChange(field.text,e.target.files[0])} hidden required = {field.required}/>
                  </label>
                 )}
                
                {/* Render Select Dropdown */}
                {field.type === 'Option' && (
                  <select
                    className="w-full px-4 py-2 text-gray-700 transition-all bg-white border border-gray-300 rounded-lg outline-none appearance-none focus:ring-2 focus:ring-blue-500"
                      onChange={(e) => handleInputChange(field.text,e.target.value)}
                  required = {field.required} defaultChecked = ''>
                    <option value="" disabled> {field.placeholder}</option>
                    {field.options?.map((opt, idx) => (
                      <option key={idx} value={opt}>{opt}</option>
                    ))}
                  </select>
                )}
                {/* Render Description (textarea) */}
                {field.type === 'Description' && (
                  <textarea placeholder= {field.placeholder} className="w-full px-2 text-gray-700 transition-all border border-gray-300 rounded-lg outline-none h-28 focus:ring-2 focus:ring-blue-500 focus:border-transparent" required = {field.required}   onChange={(e) => handleInputChange(field.text,e.target.value)}></textarea>
                )}
                
              </div>
            ))
          ) : (
            <div className="p-4 italic text-center text-gray-500 bg-gray-100 rounded-lg">
              No custom fields required for this service.
            </div>
          )}

          <div className="pt-4">
            <button
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg shadow-lg transform active:scale-[0.98] transition-all"
            >
              Continue to Payment
            </button>
          </div>
        </form>

      </div>
    </div>
    <Footer />
    </>
  );
};

export default BookingPage;